import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext } from '../ModalContext'
import { useGetExercises } from 'redux/customHooks/useGetExercises'
import { GetProgressionLevelName } from 'functions/textUtils'

import MediumLoadingComponent from 'components/Loading/MediumLoadingComponent'
import ExerciseProgressionObject from 'components/ProgramGenerator/ExerciseProgressionObject'

export default function SlotExerciseProgressionDetailsModal() {
    const { modalData } = useContext(ModalContext)
    const { exercises } = useGetExercises()

    const latestProgramSnapshot = useSelector(state => state.trainingChart.latestProgramSnapshot)
    const programTable = latestProgramSnapshot.programTable

    const workoutTemplateKey = modalData.workoutTemplateKey
    const phaseIndex = modalData.phaseIndex
    const slotIndex = modalData.slotIndex

    const slotExerciseProgressionConfig = latestProgramSnapshot.slotExerciseProgressionConfig[workoutTemplateKey]
    const phaseConfig = slotExerciseProgressionConfig.phases[phaseIndex]
    const slotConfig = phaseConfig.slots[slotIndex]
    
    const GetProgressionLevelColor = (progressionLevel) => {

        var style = ''

        if (progressionLevel === 0) style += 'bg-orange-100 '
        else if (progressionLevel === 1) style += 'bg-orange-200 '
        else if (progressionLevel === 2) style += 'bg-orange-300 '
        else if (progressionLevel === 3) style += 'bg-orange-400 '
        else if (progressionLevel === 4) style += 'bg-orange-500 '

        return style

    }

    if (exercises.length === 0) return <MediumLoadingComponent />

    // return (
    //     <div>
    //         <div className='text-left p-6 bg-gray-200 rounded-xl'>
    //             <pre>{JSON.stringify(slotConfig, null, 2)}</pre>
    //         </div>
    //     </div>
    // )

    // NEW CONFIG OBJECT

    if (slotConfig.fullExerciseProgressionConfig && slotConfig.clampedExerciseProgressionConfig) {

        return (
            <div className='px-6 space-y-4 text-left'>
                <div>
                    Progression Type: <strong>{slotConfig.progressionType}</strong>
                </div>

                <div className='space-y-2'>
                    <div className='text-left p-6 bg-gray-200 rounded-xl'>
                        <pre>{JSON.stringify(slotConfig.progressionFilters, null, 2)}</pre>
                    </div>
                </div>

                <div>Full Progression Config</div>

                {/* 
                <div className='text-left p-6 bg-gray-200 rounded-xl'>
                    <pre>{JSON.stringify(slotConfig.fullExerciseProgressionConfig, null, 2)}</pre>
                </div> 
                */}

                <div className='w-full flex p-2 gap-x-2 bg-gray-200 rounded-xl overflow-x-scroll text-xs [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
                    {slotConfig.fullExerciseProgressionConfig.map((exercise, index) => (
                        <div key={index}>
                            <ExerciseProgressionObject
                                exercises={exercises}
                                exercise={exercise}
                            />
                        </div>
                    ))}
                </div>

                <div>Clamped Progression Config</div>
                
                {/* 
                <div className='text-left p-6 bg-gray-200 rounded-xl'>
                    <pre>{JSON.stringify(slotConfig.clampedExerciseProgressionConfig, null, 2)}</pre>
                </div>  
                */}
               
                 <div className='w-full flex p-2 gap-x-2 bg-gray-200 rounded-xl overflow-x-scroll text-xs [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
                    {slotConfig.clampedExerciseProgressionConfig.map((exercise, index) => (
                        <div key={index}>
                            <ExerciseProgressionObject
                                exercises={exercises}
                                exercise={exercise}
                            />
                        </div>
                    ))}
                </div> 

                <div>Progression Array</div>

                <div className='w-full flex p-2 gap-x-2 bg-gray-200 rounded-xl overflow-x-scroll text-xs [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
                    {programTable.map((programTableColumn) => (
                        <div key={programTableColumn.programWeekIndex}>
                            <ExerciseProgressionObject
                                exercises={exercises}
                                programTableColumn={programTableColumn}
                                exercise={programTableColumn.exerciseData[workoutTemplateKey][phaseIndex]['slots'][slotIndex]}
                            />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    // LEGACY MULTI LANE CONFIG OBJECT

    return (
        <div className='px-6 space-y-4 text-left'>
            <div>
                Progression Type: <strong>{slotConfig.progressionType}</strong>
            </div>

            <div className='space-y-2'>
                <div className='text-left p-6 bg-gray-200 rounded-xl'>
                    <pre>{JSON.stringify(slotConfig.progressionFilters, null, 2)}</pre>
                </div>
            </div>

            <div>Final Progression</div>

            <div className='w-full flex p-2 gap-x-2 bg-gray-200 rounded-xl overflow-x-scroll text-xs'>
                {programTable.map((programTableColumn) => (
                    <div key={programTableColumn.programWeekIndex}>
                        <ExerciseProgressionObject
                            exercises={exercises}
                            programTableColumn={programTableColumn}
                            exercise={programTableColumn.exerciseData[workoutTemplateKey][phaseIndex]['slots'][slotIndex]}
                        />
                    </div>
                ))}
            </div>

            <div>Multi Lane Config</div>

            <div className='space-y-4'>
                {Object.keys(slotConfig.multiLaneProgressionConfig).reverse().map((key) => (
                    <div 
                        key={key}
                        className='space-y-2'
                    >

                        <div 
                            className={`
                                ${GetProgressionLevelColor(parseInt(key))}
                                w-40 text-center rounded-xl
                            `}
                        >
                            ({key}) {GetProgressionLevelName(key)}
                        </div>

                        <div className='w-full flex p-2 gap-x-2 bg-gray-200 rounded-xl overflow-x-scroll text-xs'>
                            {slotConfig.multiLaneProgressionConfig[key].map((exercise, index) => (
                                <div key={index}>
                                    <ExerciseProgressionObject
                                        exercises={exercises}
                                        exercise={exercise}
                                    />
                                </div>
                            ))}
                        </div>

                    </div>
                ))}
            </div>
        </div>
    )
}
